import { getActiveSystem } from '../config/system';

/** A campaign's address under its own system (issue 1473), and whether reaching it means a full load. */
export function campaignHref(c, hash = '') {
  return `/campaigns?id=${encodeURIComponent(c.id)}${c.system ? `&system=${encodeURIComponent(c.system)}` : ''}${hash}`;
}
// The system is read once per page load (config/system.js), so a campaign of
// another system is opened with a full load: everything inside it (parties,
// the wiki, NPCs, players) then asks under that campaign's own system.
export const needsFullLoad = (c) => !!c.system && c.system !== getActiveSystem();

/** A campaign's wiki: its own page, the same address for the DM and the players (issue 1565). */
export function wikiHref(w) {
  return `/wiki?campaign=${encodeURIComponent(w.id)}${w.system ? `&system=${encodeURIComponent(w.system)}` : ''}`;
}

/** Open a wiki under its campaign's own system: in the page when the system is this page's, else by a full load. */
export function openWiki(navigate, w, replace = false) {
  const href = wikiHref(w);
  if (!needsFullLoad(w)) { navigate(href, { replace }); return; }
  if (replace) window.location.replace(href); else window.location.assign(href);
}

/**
 * Whether a person may sit at a campaign's table (VTT issue 1577): its owner, who is its DM, or a live seat in any of
 * its parties. Someone who only runs one there (a party's GM, a co-GM, `seated` false) is not let in. Read from a
 * campaign of `GET /api/users/me/games`; every Open table, VTT button and the homepage's card asks this one rule.
 */
export const mayOpenTable = (c) => !!c && (c.role === 'owner' || (c.seats || []).some((s) => s.seated === true));

/** A campaign's table on the site (VTT issue 1578: one per campaign), the door that hands off to the VTT. */
export const tableHref = (campaignId) => `/table/${encodeURIComponent(campaignId)}`;
